import InnerPageBSchemes from './InnerPageBSchemes';
export default InnerPageBSchemes;
